<template>
  <div class="Action-form Action-form--text">
    <div class="Grid--beta">
      <div v-if="action.description" class="Action-form__description">
        <vue-markdown
          class="Action-form__inner__description"
          :postrender="addClasses"
          >{{ action.description }}</vue-markdown
        >
      </div>
    </div>
    <div class="Action-form__input__area">
      <TextAreaInput
        class="Form-input__item"
        v-model="message"
        :disabled="isDisabled"
        :resizable="true"
        :remainingCount="!isDisabled ? charactersRemaining : null"
        @input="updateTextDebounced"
        placeholder="Ange din process här"
        @resize="resize"
        @resizedone="resizedone"
        :extraHeight="true"
      />
    </div>
    <div v-if="!isApplicant" class="Action-form__controls">
      <ToggleInput
        :value="approved"
        :disabled="!action.isValid || !isDisabled"
        text="Godkänt krav"
        @input="handleChangeApproved"
      />
      <div v-if="!approved">
        <button
          v-if="submitted"
          class="Button Button--secondary"
          @click="unlockAction"
        >
          Lås upp för komplettering
        </button>
        <button
          v-if="!submitted"
          class="Button Button--primary"
          @click="lockAction"
        >
          Avsluta komplettering
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import TextAreaInput from "@/components/forms/TextAreaInput";
import ToggleInput from "@/components/forms/ToggleInput";
import { debounce } from "debounce";
import VueMarkdown from "vue-markdown";

export default {
  name: "ApplicationActionText",
  components: { TextAreaInput, ToggleInput, VueMarkdown },
  props: {
    action: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      message: this.action.text,
      isSubmitLoading: false,
      hasError: false,
      maxChar: 4000
    };
  },
  computed: {
    ...mapGetters("memberStore", ["isApplicant"]),
    ...mapState("applicationStore", ["application"]),
    approved() {
      return this.action.status === "APPROVED";
    },
    submitted() {
      return this.action.status === "IN_REVIEW";
    },
    isDisabled() {
      return this.submitted || this.approved;
    },
    // canBeConfirmed () {
    //   return ['IN_PROGRESS', 'SUBMITTED', 'CONFIRMED'].indexOf(this.action.status) > -1 && !this.disabled
    // },
    charactersRemaining() {
      return this.message && this.message.length
        ? this.maxChar - this.message.length
        : this.maxChar;
    }
  },
  methods: {
    ...mapActions("applicationStore", [
      "approveAction",
      "updateText",
      "submitAction"
    ]),
    handleChangeConfirmed(isChecked) {
      this.approveAction({
        actionId: this.action.id,
        approved: isChecked
      });
    },
    updateTextDebounced: debounce(function(value) {
      this.updateText({
        actionId: this.action.id,
        text: value
      });
    }, 1000),
    handleChangeApproved(isChecked) {
      this.approveAction({
        actionId: this.action.id,
        approved: isChecked
      });
    },
    unlockAction() {
      this.submitAction({
        actionId: this.action.id,
        submitted: false
      });
    },
    lockAction() {
      this.submitAction({
        actionId: this.action.id,
        submitted: true
      });
    },
    addClasses(html) {
      return html
        .replace("<h1>", '<p class="Action-form__header">')
        .replace("<h2>", '<p class="Action-form__header">');
    },
    resize() {
      this.$emit("resize");
    },
    resizedone() {
      this.$emit("resizedone");
    }
  }
};
</script>

<style lang="scss" scoped>
.Button--primary-inactive {
  opacity: 0.7;
}
</style>
